// extracted by mini-css-extract-plugin
export default {"listagem":"ListagemItens_listagem__kotgM","carrousel":"ListagemItens_carrousel__iwQyD"};